import Alert from '@mui/material/Alert';

interface Props {
  readonly wish?: string;
}

export const LimitedFeature = ({
  wish = 'faire évoluer ces données',
}: Readonly<Props>) => (
  <Alert severity="warning" sx={{ mb: 2 }}>
    Veuillez vous rapprocher du service informatique si vous souhaitez {wish}.
  </Alert>
);
